<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>工单详情</span>
    </div>
    <!-- 客户信息部分 -->
    <div class="client-info">
      <img :src="infoObj.img" mode="" />
      <div>
        <div>
          <span>{{ showDetail.roomLocation }}</span>
          <span
            :style="{
              color:
                showDetail.repairStatus == 1
                  ? '#FFBA18'
                  : showDetail.repairStatus == 2
                  ? '#46CC5E'
                  : '#808080',
              'background-color':
                showDetail.repairStatus == 1
                  ? '#FFEEC4'
                  : showDetail.repairStatus == 2
                  ? '#D5FCCC'
                  : '#F3F3F3',
            }"
            >{{
              showDetail.repairStatus == 1
                ? "待分配"
                : showDetail.repairStatus == 2
                ? "处理中"
                : showDetail.repairStatus == 3
                ? "已处理"
                : showDetail.repairStatus == 4
                ? "已撤回"
                : "已关闭"
            }}</span
          >
        </div>
        <span>创建时间:{{ showDetail.createDateStr }}</span>
        <span>工单内容: {{ showDetail.repairContent }}</span>
      </div>
    </div>
    <!-- 跟进时间轴部分 -->
    <div class="time-line">
      <div class="title-text">处理记录</div>
      <a-timeline>
        <a-timeline-item
          v-for="(item, index) in showDetail.histories"
          :key="index"
        >
          <div>跟进时间：{{ item.createDateStr }}</div>
          <div>跟进人:{{ item.operate }}</div>
          <div>跟进状态:{{ item.status }}</div>
          <div>跟进事项:{{ item.reason }}</div>
          <div class="imgBox">
            <img
              :src="item.url"
              v-for="(item, index) in showDetail.resources"
              :key="index"
            />
          </div>
        </a-timeline-item>
        <!-- <a-timeline-item>
          <div>跟进时间：2021-12-11 12:34</div>
          <div>跟进人:陈晓晓</div>
          <div>跟进状态:初步意向</div>
          <div>跟进事项:上门拜访客户,向客户介绍房间详</div>
        </a-timeline-item>
        <a-timeline-item>
          <div>跟进时间：2021-12-11 12:34</div>
          <div>跟进人:陈晓晓</div>
          <div>跟进状态:初步意向</div>
          <div>跟进事项:上门拜访客户,向客户介绍房间详</div>
        </a-timeline-item> -->
      </a-timeline>
    </div>
    <!-- 撤回工单部分 -->
    <div class="contact-method">
      <a-button
        type="primary"
        style="background: #1584FF;box-shadow: 0px 2px 8px 0px #80BCFF;border-radius: 8px;width: 90%;height: 44px;margin: 0 auto;"
        v-if="showDetail.repairStatus == 1&&currentPermission.rwAccessStatus==2"
        @click="rebackSubmit = true"
      >
        撤回工单
      </a-button>
      <a-button
        type="primary"
        style="background: #1584FF;box-shadow: 0px 2px 8px 0px #80BCFF;border-radius: 8px;width: 90%;height: 44px;margin: 0 auto;"
        v-if="showDetail.repairStatus == 2&&currentPermission.rwAccessStatus==2"
        @click="dealSubmit = true"
      >
        处理工单
      </a-button>
    </div>
    <!-- 撤回工单弹窗 -->
    <van-popup v-model="rebackSubmit" position="bottom">
      <div>
        <div class="order-title">
          撤回工单
        </div>
        <div class="order-form">
          <a-form-model
            ref="rebackForm"
            :model="rebackForm"
            :rules="rebackRules"
          >
            <a-form-model-item
              ref="repairContent"
              label="处理内容"
              prop="repairContent"
              style="margin-top: 0.4rem;"
            >
              <a-textarea
                v-model="rebackForm.repairContent"
                placeholder="请输入处理内容"
                :auto-size="{ minRows: 3, maxRows: 5 }"
                style="margin-top: 0.3rem;width: 97%;"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <!-- 确认/取消部分 -->
        <div class="btn-method">
          <a-button
            style="border-radius: 8px;margin-right:0.7rem;"
            @click="rebackSubmit = false"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            style="border-radius: 8px;"
            @click="confirmRebackForm"
          >
            确定
          </a-button>
        </div>
      </div>
    </van-popup>
    <!-- 处理工单弹窗 -->
    <van-popup v-model="dealSubmit" position="bottom">
      <div>
        <div class="order-title">
          处理工单
        </div>
        <div class="order-form">
          <a-form-model ref="dealForm" :model="dealForm" :rules="dealRules">
            <a-form-model-item
              ref="handleContent"
              label="处理内容"
              prop="handleContent"
              style="margin-top: 0.4rem;margin-bottom: 0;"
            >
              <a-textarea
                v-model="dealForm.handleContent"
                placeholder="请输入处理内容"
                :auto-size="{ minRows: 3, maxRows: 5 }"
                style="margin-top: 0.3rem;width: 97%;"
              />
            </a-form-model-item>
            <a-form-model-item
              ref="repairExpense"
              prop="repairExpense"
              style="margin-top: 0.4rem;margin-bottom: 0;"
            >
              <div
                style="margin-top: 0.3rem;border-bottom: 1px solid #F3F3F3;padding:0.2rem 0;"
              >
                <van-field
                  v-model="dealForm.repairExpense"
                  label="处理费用"
                  placeholder="请输入"
                  input-align="right"
                />
              </div>
            </a-form-model-item>
            <a-form-model-item
              ref="handleDateTimeStr"
              label="处理时间"
              prop="handleDateTimeStr"
              style="display:flex;align-items:center;border-bottom: 1px solid #F3F3F3;padding:0.3rem 0;margin-bottom: 0.4rem;"
            >
              <div @click="timeFormShow = true" class="typeSelect">
                <span style="margin-right:0.15rem;">{{dealFormText.timeText.substring(0,9)}}</span>
                <span>{{dealFormText.timeText.substring(10)}}</span>
                <a-icon type="down" style="" />
              </div>
            </a-form-model-item>
            <a-form-model-item label="上传图片">
              <van-uploader
                v-model="fileList"
                multiple
                style="margin-top: 0.3rem;border-radius: 4px;"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <!-- 确认/取消部分 -->
        <div class="btn-method">
          <a-button
            style="border-radius: 8px;margin-right:0.7rem;"
            @click="dealSubmit = false"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            style="border-radius: 8px;"
            @click="dealFormConfirm"
          >
            确定
          </a-button>
        </div>
      </div>
    </van-popup>
    <!-- 处理表单时间选择 -->
    <van-popup v-model="timeFormShow" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择完整时间"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="timeFormShow=false"
        @confirm="timeConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  orderDetail,
  rebackOrder,
  dealOrder,
  imgUpload,
} from "../axios/property";
export default {
  data() {
    return {
      rebackSubmit: false, // 撤回工单弹窗
      dealSubmit: false, // 处理工单弹窗
      timeFormShow: false, // 处理工单中的时间选择
      rebackForm: {
        repairContent: "",
      },
      dealForm: {
        handleContent: "",
        repairExpense: "",
        handleDateTimeStr: "",
        resources: [],
      },
      dealFormText: {
        timeText: '请选择'
      },
      rebackRules: {
        repairContent: [
          {
            required: true,
            message: "请输入处理内容",
            trigger: "blur",
          },
        ],
      },
      dealRules: {
        handleContent: [
          {
            required: true,
            message: "请输入处理内容",
            trigger: "blur",
          },
        ],
        handleDateTimeStr: [
          {
            required: true,
            message: "请选择处理时间",
            trigger: "blur",
          },
        ],
      },
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      fileList: [], // 上传图片时的图片数组
      infoObj: {}, // 详细数据
      showDetail: {}, // 展示的详细数据
      currentPermission: {}, // 权限信息
    };
  },
  created() {
    this.infoObj = this.$route.params.obj;
    this.currentPermission = this.$store.state.initialData.currentPermission
    this.getOrderDetail();
  },
  methods: {
    formatter(type, val) { // 时间选择格式
      console.log(type)
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'hour') {
        return `${val}时`;
      } else if (type === 'minute') {
        return `${val}分`;
      }
      return val;
    },
    getOrderDetail() {
      // 获取工单详情数据
      let that = this;
      orderDetail(this.infoObj.id).then((res) => {
        if (res.data.code == 0) {
          console.log(res);
          that.showDetail = res.data.data;
        }
      });
    },
    confirmRebackForm() {
      // 撤回工单表单确认
      let that = this;
      this.$refs.rebackForm.validate((valid) => {
        if (valid) {
          let requestData = {
            ...that.rebackForm,
            id: that.showDetail.id
          };
          rebackOrder(requestData).then((res) => {
            if (res.data.code == 0) {
              that.$message.success("撤回成功");
              that.getOrderDetail();
            } else {
              that.$message.error("撤回失败,请稍后重试");
            }
            that.rebackSubmit = false;
          });
        } else {
          return false;
        }
      });
    },
    dealFormConfirm() {
      // 处理工单表单确认
      console.log(this.fileList);
      console.log(this.dealForm);
      let that = this;
      this.$refs.dealForm.validate((valid) => {
        if (valid) {
          let imgNum = 0;
          for (let i = 0; i < this.fileList.length; i++) {
            let formData = new FormData();
            console.log(this.fileList[i].file);
            formData.append("file", this.fileList[i].file); // 文件对象
            imgUpload(formData).then((res) => {
              // 上传平面图
              console.log(res);
              if (res.data.code == 0) {
                that.dealForm.resources.push(res.data.data[0]);
                imgNum++;
              } else {
                that.$message.error("上传失败,请稍后重试");
                return;
              }
            });
          }
          setTimeout(function() {
            if (imgNum == that.fileList.length) {
              let requestData = {
                id: that.showDetail.id,
                ...that.dealForm,
              };
              dealOrder(requestData).then((res) => {
                console.log(res);
                if (res.data.code == 0) {
                  that.$message.success("处理成功");
                  that.getOrderDetail();
                } else {
                  that.$message.error("处理失败,请稍后重试");
                }
              });
              that.dealSubmit = false;
            }
          }, 500);
        } else {
          console.log("表单数据不完整");
          return false;
        }
      });
    },
    timeConfirm(value) {
      // 处理表单中的时间选择
      console.log(value.toLocaleString("chinese", { hour12: false }));
      this.dealForm.handleDateTimeStr = value.toLocaleString("chinese", {
        hour12: false,
      }).replaceAll('/','-');
      this.dealFormText.timeText = value.toLocaleString("chinese", {
        hour12: false,
      }).replaceAll('/','-');
      this.timeFormShow = false
      this.$refs.dealForm.clearValidate("handleDateTimeStr");
    },
    backPage() {
      // 回退页面
      this.$router.push("/order-list");
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  height: 100vh;
  position: relative;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 客户信息部分 */
.client-info {
  display: flex;
  padding: 0.2rem 0.2rem;
  background-color: white;
  border-bottom: 1px solid #f3f3f3;
  box-shadow: 0px 4px 8px 0px #e5e5e5;
}
.client-info img {
  width: 1.5rem;
  height: 1.5rem;
}
.client-info > div {
  width: 79%;
  display: flex;
  flex-direction: column;
  margin-right: auto;
  margin-left: 0.3rem;
}
.client-info > div > div {
  margin-bottom: 0.07rem;
  display: flex;
  align-items: center;
}
.client-info > div > div span:nth-child(1) {
  margin-right: auto;
  font-size: 0.45rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.client-info > div > div span:nth-child(2) {
  width: 1.7rem;
  height: 0.55rem;
  background: #f3f3f3;
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #808080;
  text-align: center;
  padding: 0.03rem 0;
}
.client-info div > span:nth-child(2) {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-bottom: 0.07rem;
}
.client-info div > span:nth-child(3) {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
/* 跟进时间轴部分 */
.time-line {
  padding: 0.5rem 0.3rem;
}
.time-line .title-text {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin-bottom: 0.5rem;
}
.time-line .imgBox {
  display: flex;
  margin-top: 0.1rem;
}
.imgBox img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.2rem;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.time-line /deep/.ant-timeline-item-content {
  background-color: white;
  padding: 0.1rem 0.2rem;
  border: 1px solid #e9e9ea;
  border-radius: 5px;
  line-height: 0.7rem;
}
.time-line /deep/.ant-timeline-item-head {
  width: 15px;
  height: 15px;
  left: -2px;
}
/* 撤回工单部分 */
.contact-method {
  display: flex;
  background: #ffffff;
  align-items: center;
  margin-top: 0.3rem;
  justify-content: center;
  padding: 0.3rem 0.4rem;
  position: fixed;
  bottom: 0;
  width: 100%;
}
/* 提交工单弹窗 */
.order-title {
  width: 100%;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  font-size: 0.45rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  border-bottom: 1px solid #f3f3f3;
}
.order-form {
  padding-left: 0.4rem;
}
.order-form /deep/.ant-form-item-label {
  padding: 0px;
}

/deep/.van-cell {
  padding: 0px;
  width: 97%;
}
/* 确认/取消部分 */
.btn-method {
  display: flex;
  height: 1.5rem;
  background: #ffffff;
  align-items: center;
  margin-top: 0.1rem;
  justify-content: center;
  box-shadow: 0px -2px 4px 0px #efefef;
}
.btn-method /deep/.ant-btn {
  width: 39%;
  height: 1.1rem;
}
/* 处理工单弹窗 */
.typeSelect {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #cbcdcc;
  margin-left: auto;
  justify-content: flex-end;
  margin-right: 0.4rem;
  line-height: 20px;
}
</style>
